import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    foundBug: 'Нашли баг?',
    reportBug: 'Сообщить о баге',
    dialogTitle: 'Нашли баг?',
    dialogBody:
      'Расскажите о нём в нашем Telegram-боте: что делали, что ожидали и что получилось. Скриншот или видео очень помогут — так мы починим быстрее.',
    openBot: 'Написать в бот',
  },
  en: {
    foundBug: 'Found a bug?',
    reportBug: 'Report a bug',
    dialogTitle: 'Found a bug?',
    dialogBody:
      'Tell us about it in our Telegram bot: what you did, what you expected and what happened. A screenshot or a video helps a lot — we’ll fix it faster.',
    openBot: 'Message the bot',
  },
})
